import React from 'react';
import { FormattedMessage } from 'react-intl';
import { workingIndicatorMessages as messages } from './workingIndicator.i18n';

export class WorkingIndicator extends React.Component {
  render() {
    return (
      <div style={{ textAlign: 'center', margin: 'auto', display: 'inline-block', width: '100%' }}>
        <div className="fa fa-spinner fa-spin fa-3x"></div>
        <div><FormattedMessage {...messages.text.working} /></div>
      </div>
    );
  }
}

export default WorkingIndicator;
